import React, { forwardRef } from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  highlighted?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  children,
  className = '',
  highlighted = false,
  ...props
}, ref) => {
  return <div ref={ref} className={`bg-white rounded-2xl shadow-md overflow-hidden ${highlighted ? 'ring-4 ring-[#0D7377] shadow-xl relative' : 'border border-slate-100'} ${className}`} {...props} data-id="element-291">
        {children}
      </div>;
});
Card.displayName = 'Card';